export default __webpack_public_path__ + "static/workshop-cfc8a759be3b86b4439307f60f470c5d.webp";